/**
 * The subset of input types that render as a text input.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types
 */
const TEXT_INPUT_TYPES = [
    'text',
    'email',
    'number',
    'password',
    'search',
    'tel',
    'url',
];
/**
 * Check if the given element is an input element that accepts
 * text (i.e. not a checkbox or radio etc.) or textarea element.
 */
function isTextInput(el) {
    return (el.tagName === 'TEXTAREA' ||
        (el.tagName === 'INPUT' &&
            TEXT_INPUT_TYPES.includes(el.type)));
}
function isTextEditableElement(el) {
    return el instanceof HTMLElement && (isTextInput(el) || el.isContentEditable);
}
/**
 * Check if the given element is a non-text <input>, like a checkbox or radio button.
 */
function isNonTextInput(el) {
    return (el.tagName === 'INPUT' &&
        !TEXT_INPUT_TYPES.includes(el.type));
}
/**
 * Get the first text-like input or textarea found under the given `root`. It is possible that someone could
 * add other input types (like checkbox) inside of our `Input.Root` that we should ignore.
 */
function getFirstTextInput(root) {
    const inputs = root.querySelectorAll('input, textarea');
    for (const input of inputs) {
        if (isTextInput(input))
            return input;
    }
    return null;
}

export { TEXT_INPUT_TYPES, getFirstTextInput, isNonTextInput, isTextEditableElement, isTextInput };
//# sourceMappingURL=input.js.map
